"use strict";

var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __importDefault = void 0 && (void 0).__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var spaui_utils_1 = require("@tencent/spaui-utils");
var info_1 = __importDefault(require("./info"));
var odc_meta_1 = __importDefault(require("@tencent/odc-meta"));
var odc_meta_form_group_1 = __importDefault(require("@tencent/odc-meta-form-group"));
var odc_meta_content_1 = __importDefault(require("@tencent/odc-meta-content"));
var odc_meta_input_1 = __importDefault(require("@tencent/odc-meta-input"));
var util_1 = require("./util");
var legacyClassNameMap = {
  MetaFormGroup: 'mete-form-group mete-form-group-legacy',
  MetaInput: 'mete-input-legacy',
  MetaInputBorder: 'mete-input-border-legacy',
  MetaInputWrapper: 'meta-input-wrapper-legacy'
};
var MetaInputPanel = function MetaInputPanel(props) {
  var _a = props.Label,
    Label = _a === void 0 ? null : _a,
    // eslint-disable-line
    _b = props.label,
    // eslint-disable-line
    label = _b === void 0 ? null : _b,
    // eslint-disable-line
    _c = props.error,
    // eslint-disable-line
    error = _c === void 0 ? '' : _c,
    status = props.status,
    _d = props.maxLength,
    maxLength = _d === void 0 ? 0 : _d,
    _e = props.feedback,
    feedback = _e === void 0 ? null : _e,
    feedbackSpace = props.feedbackSpace,
    _f = props.disabled,
    disabled = _f === void 0 ? false : _f,
    _g = props.readOnly,
    readOnly = _g === void 0 ? false : _g,
    _h = props.value,
    value = _h === void 0 ? '' : _h,
    feedbackAddons = props.feedbackAddons,
    _j = props.clear,
    clear = _j === void 0 ? false : _j,
    _k = props.onClear,
    onClear = _k === void 0 ? void 0 : _k,
    _l = props.MetaFormGroupClassName,
    MetaFormGroupClassName = _l === void 0 ? '' : _l,
    // eslint-disable-line
    _m = props.feedbackClassName,
    // eslint-disable-line
    feedbackClassName = _m === void 0 ? '' : _m,
    _o = props.MetaFormGroupAddons,
    MetaFormGroupAddons = _o === void 0 ? '' : _o,
    // eslint-disable-line
    MetaFormGroupPrefix = props.MetaFormGroupPrefix,
    // eslint-disable-line
    MetaFormGroupProps = props.MetaFormGroupProps,
    // eslint-disable-line
    _p = props.helpBlock,
    // eslint-disable-line
    helpBlock = _p === void 0 ? '' : _p,
    direction = props.direction,
    legacy = props.legacy,
    _q = props.helpBlockClassName,
    helpBlockClassName = _q === void 0 ? '' : _q,
    _r = props.placeholder,
    placeholder = _r === void 0 ? '' : _r,
    onChange = props.onChange,
    onFocus = props.onFocus,
    onBlur = props.onBlur,
    _s = props.InputProps,
    InputProps = _s === void 0 ? {} : _s,
    // eslint-disable-line
    children = props.children,
    helpTips = props.helpTips,
    _t = props.useTextarea,
    useTextarea = _t === void 0 ? false : _t,
    _u = props.useDiv,
    useDiv = _u === void 0 ? false : _u,
    _v = props.muiltline,
    muiltline = _v === void 0 ? false : _v,
    _w = props.isNotFullWidthCharacter,
    isNotFullWidthCharacter = _w === void 0 ? false : _w,
    metaProps = props.metaProps;
  var classNameMap = props.classNameMap;
  if (legacy) {
    classNameMap = legacyClassNameMap;
  }
  return react_1["default"].createElement(odc_meta_1["default"], __assign({
    type: "input",
    direction: direction,
    classNameMap: classNameMap,
    legacy: legacy
  }, metaProps, (0, spaui_utils_1.globalProps)(props, {
    supportAllEvents: true
  }, MetaInputPanel)), Label || label, react_1["default"].createElement(odc_meta_content_1["default"], {
    classNameMap: classNameMap
  }, children ? children : react_1["default"].createElement(odc_meta_form_group_1["default"], __assign({
    error: error,
    status: status,
    feedback: maxLength ? react_1["default"].createElement(react_1["default"].Fragment, null, react_1["default"].createElement("span", {
      className: "spaui-input-feedback-group"
    }, react_1["default"].createElement("span", {
      className: "spaui-input-feedback-count"
    }, isNotFullWidthCharacter === true ? value.length : (0, util_1.getFullWidthCharacterStrLength)(value)), react_1["default"].createElement("span", {
      className: "spaui-input-feedback-divider"
    }, "/"), react_1["default"].createElement("span", {
      className: "spaui-input-feedback-range"
    }, maxLength)), feedbackAddons) : feedback,
    clear: clear,
    onClear: onClear,
    className: (0, classnames_1["default"])(MetaFormGroupClassName, {
      disabled: disabled,
      readonly: readOnly,
      'has-textarea': useTextarea || useDiv
    }),
    classNameMap: classNameMap,
    feedbackSpace: feedbackSpace,
    feedbackClassName: feedbackClassName,
    addons: MetaFormGroupAddons,
    helpBlock: helpBlock,
    helpBlockClassName: helpBlockClassName,
    prefix: MetaFormGroupPrefix,
    helpTips: helpTips
  }, MetaFormGroupProps), react_1["default"].createElement(odc_meta_input_1["default"], __assign({
    value: value,
    placeholder: placeholder,
    onChange: onChange,
    onFocus: onFocus,
    onBlur: onBlur,
    // classNameMap={classNameMap}
    disabled: disabled,
    // readOnly={readOnly}
    useTextarea: useTextarea,
    muiltline: muiltline,
    useDiv: useDiv
  }, InputProps)))));
};
(0, spaui_utils_1.setComponentMark)(MetaInputPanel, info_1["default"]);
exports["default"] = react_1["default"].memo(MetaInputPanel);